<template>
  <div ref="draggableContainer">
    <v-card :elevation="24" min-width="400">
      <v-card-title
        @mousedown="dragMouseDown"
        class="justify-center draggable-container"
      >
        <span class="text-h6">{{ $t('version.popin_title') }}</span>
        <v-btn icon @click="closeHandler" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="version-info-wrapper">
          <div v-html="$t('version.popin', { version: version })" />
          <a class="release-note-link" :href="getPathName(version)">
            {{ $t('version.releaseNote') }} {{ version }}
          </a>
        </v-container>
        <div class="version-displayer-button-div">
          <v-btn
            dark
            rounded
            small
            :color="buttonColor"
            class="text-none version-displayer-button"
            @click.stop="closeHandler"
            data-cy="validateVersionButton"
            >{{ $t('version.understood') }}</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator';
import _color from '@/helpers/colors';
import DraggableComponent from '@/components/Mixins/DraggableComponent.vue';
import _cookie from '@/helpers/cookieHelper';
import VersionMixin from '@/components/Mixins/VersionMixin.vue';

@Component
export default class VersionDisplayer extends Mixins(
  DraggableComponent,
  VersionMixin
) {
  private buttonColor: string = _color.pinkButton;
  private async closeHandler() {
    // TODO save this in local storage: data should not expire after 15 days: 15 days after release, the version displayer should stop popping for every users instead (see #37171)
    await _cookie.setCookie('version', process.env.VITE_VERSION, 15);
    this.$emit('close-popin');
  }
  get version(): string | undefined {
    return process.env.VITE_VERSION;
  }
}
</script>

<style lang="stylus" scoped>
.draggable-container {
  cursor: grab;
  position: relative;
}
  .version-info {
    width: 100%;
  }

  .version-displayer-button-div {
    width 100%;
    .version-displayer-button {
      left: 50%;
      transform: translateX(-50%);
    }
  }

.release-note-link {
  display: inline-block;
  margin-top: 16px;
}

.close-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
